import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
    isLoading: true,
  }
}

export function fulfilled(state, payload, result) {
  const userChapters = {}
  result.map(c => {
    if (!userChapters[c.userId]) {
      userChapters[c.userId] = {}
    }
    userChapters[c.userId][c.kapitelId] = {
      id: c.kapitelId,
      status: c.status,
      lastStatusChange: c.lastStatusChange,
    }
    return undefined
  })

  return {
    ...state,
    chapterStatuses: {
      ...state.chapterStatuses,
      ...userChapters,
    },
    isLoading: false,
  }
}

export function rejected(state, pl, error) {
  return {
    ...state,
    isLoading: false,
    ausbildungsPlanError: error && error.message ? error.message : i18n.t('misc_unknown_error'),
  }
}

export async function action() {
  try {
    return await Api.getAllChaptersStatusByUser()
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
